var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',{staticClass:"p-4 justify-content-center",staticStyle:{"height":"300px"}},[(_vm.sources.length)?_c('apexchart',{attrs:{"type":"donut","height":"100%","width":"100%","series":_vm.series,"options":_vm.chartOptions}}):_c('span',[_vm._v("- No Data")])],1):_c('div',[_c('ScoreComparisonLoader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }